import { Tooltip } from "@client/components/utils/Tooltip";
import InfoIcon from "@client/icons/InfoIcon";
import clsx from "clsx";

export default function SlidingToggle({
  state,
  onChange,
  disabled,
  label,
  info,
}: {
  state: boolean;
  onChange: (isActive: boolean) => void;
  disabled?: boolean;
  label?: string;
  info?: string;
}) {
  return (
    <label
      className={clsx(
        "flex items-center gap-1",
        disabled ? "opacity-50" : "cursor-pointer",
      )}
    >
      <span>
        {label}
        {info && (
          <Tooltip title={info}>
            <span className="inline-block align-middle ml-1">
              <InfoIcon />
            </span>
          </Tooltip>
        )}
      </span>
      <div className="relative">
        <input
          type="checkbox"
          id="toggle"
          className="sr-only"
          onChange={() => onChange(!state)}
          checked={state}
          disabled={disabled}
        />
        <div
          className={clsx(
            "block w-10 h-6 rounded-full transition-colors duration-300",
            state ? "bg-green-500" : "bg-gray-600",
          )}
        />
        <div
          className={clsx(
            "dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-300",
            state && "transform translate-x-full",
          )}
        />
      </div>
    </label>
  );
}
